import { render, staticRenderFns } from "./downloadPc.vue?vue&type=template&id=5e58ddc2&scoped=true"
import script from "./downloadPc.vue?vue&type=script&lang=js"
export * from "./downloadPc.vue?vue&type=script&lang=js"
import style0 from "./downloadPc.vue?vue&type=style&index=0&id=5e58ddc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e58ddc2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/drone/src/components/Header/index.vue').default})
